// extracted by mini-css-extract-plugin
export default {"payboard_container":"payboard_payboard_container__Xia6g","formContainer":"payboard_formContainer__dDShX","loaderContainer":"payboard_loaderContainer__f7i8G"};